import { useEffect, useState } from 'react';
import { CampaignEvaluationModal } from '../../../../components/CampaignEvaluationModal';
import { CampaignEvaluationRewardModal } from '../../../../components/CampaignEvaluationModal/CampaignEvaluationRewardModal';
import { UserAccountsService } from '../../../../services';
import {
  dismissCampaignEvaluationForSession,
  isCampaignEvaluationDismissedInSession,
} from '../../../../utils/campaignEvaluationSession';
import { submitCampaignEvaluation } from '../../../../utils/submitCampaignEvaluation';

export default function CampaignAvaliationModal({ sessionStatus, sessionUuid }) {
  const [campaingAvaliationStatus, setCampaingAvaliationStatus] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const shouldShowEvaluationModal =
    campaingAvaliationStatus !== true &&
    !isCampaignEvaluationDismissedInSession();

  useEffect(() => {
    UserAccountsService.getUserAccountsByLogin()
      .then((response) => {
        setCampaingAvaliationStatus(response?.data?.campaingAvaliation ?? null);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (sessionStatus !== 'completed') {
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const response = await UserAccountsService.getUserAccountsByLogin();
        const evaluated = response?.data?.campaingAvaliation ?? null;

        setCampaingAvaliationStatus(evaluated);

        if (
          !cancelled &&
          evaluated !== true &&
          !isCampaignEvaluationDismissedInSession()
        ) {
          setIsOpen(true);
        }
      } catch (_) {
        // ignore
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [sessionStatus, sessionUuid]);

  const handleDismiss = () => {
    dismissCampaignEvaluationForSession();
    setIsOpen(false);
  };

  const handleSend = async (rating) => {
    setIsSubmitting(true);

    try {
      const result = await submitCampaignEvaluation({
        rating: rating || 0,
        origin: 'campaignChat',
        campaignId: sessionUuid || null,
      });

      if (result.success) {
        setCampaingAvaliationStatus(true);
        setIsOpen(false);
        setIsRewardModalOpen(true);
      }
    } catch (_) {
      // keep silent in UI
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!shouldShowEvaluationModal && !isRewardModalOpen) {
    return null;
  }

  return (
    <>
      {shouldShowEvaluationModal && (
        <CampaignEvaluationModal
          isOpen={isOpen}
          onClose={handleDismiss}
          onSubmit={handleSend}
          isSubmitting={isSubmitting}
        />
      )}

      <CampaignEvaluationRewardModal
        isOpen={isRewardModalOpen}
        onClose={() => setIsRewardModalOpen(false)}
      />
    </>
  );
}
